<template>
<div style="background:white">
<div class="service-page-banner">
  <div class="service-page-banner-content">We offer a host of services</div>  
</div>


<div class="ecara-highlight">
      <div v-if="this.selectedServicePosition == 0 " style="text-align:left">
        <h4>{{$store.listItems[0]}}</h4>
        <div style="font-weight:400;margin-top:16px;margin-bottom:16px;">Process reviews and transaction checks Audits to evaluate compliance with statutory and regulatory requirements, including disclosure norms. We regularly interact with the management, in order to provide constructive and value added feedback not only on the business of the company but also about the industry. 
        </div><li>Statutory Audits
        </li><li>Tax Audits
        </li><li>Internal Audit
        </li><li>Stock Audit
        </li><li>Concurrent Audits</li>
      </div>

      <div v-if="this.selectedServicePosition == 1 " style="text-align:left">
        <h4>{{$store.listItems[1]}}</h4>
        <div style="font-weight:400;margin-top:16px;margin-bottom:16px;">The Direct Tax team of our Tax and Regulatory Services Practice possesses significant expertise in domestic and international tax matters and is committed to assist businesses in developing a resilient compliance framework, thereby empowering them to effectively manage their tax position and, thus, mitigate their tax risks 
          <br><br>We have accumulated a vast pool of knowledge and aggregated a team of professionals who are at equal ease when called upon to advise, litigate or undertake compliance audit. We understands the prevalent taxation issues that affect business and provides expertise based on a suitable assessment of risk.</div>
        <li>Tax Advisory and Planning</li>
        <li>Tax Compliances</li>
        <li>Assessments and Litigations</li>
        <li>International Taxation</li>
      </div>

      <div v-if="this.selectedServicePosition == 2 " style="text-align:left">
        <h4>{{$store.listItems[2]}}</h4>
        <div style="font-weight:500;margin-top:16px;margin-bottom:16px;">In 2017 has seen dynamic legislative changes like introduction of  GST for manufacturing, trading and service sector.
          <br><br>Considering this, our approach for Indirect Taxation Practice focus on providing a ‘same team’ concept platform where the Client has a single window to have an all inclusive solution platform - Right from the inception of an idea, drafting of agreements, business structuring, reporting of revenue, compliances, credits to tax authorities and up to the assessment.</div>
        <div style="font-weight:600;margin-top:16px;margin-bottom:16px;">We provide comprehensive advice and assistance on indirect taxes. Our services broadly cover the following</div>
        <li>Tax Advisory and Planning</li>
        <li>Tax Compliances</li>
        <li>Assessments and Litigations</li>
        <li>Regulatory Approvals</li>
        <li>GST Audit</li>

      </div>
</div>


<div class="container" style="margin-top:5%">
  <p>To take your business to the next level of success, you will require the best online platforms to interact with the targeted audience. If you want to get the maximum number of customers for your business products and services, we have the best packages at the best price to match your expectations and desires. We are able to deliver the following services to the business clients:</p>
</div>

<div class="services-wrapper container">
    <div class="card" style="width:350px" data-aos="zoom-in"  v-for="(name) of $store.listItems" v-bind:key="name">
      <router-link :to="{ name: 'services', params: {service: name } }">
      <!-- <div class="card" style="width:350px" data-aos="zoom-in" > -->
        <div class="card-image">
          <img src="../assets/frontend.png">
        </div>
        <div class="card-content" >
          <span class="card-title">{{name}}</span>
         <p></p>
        </div>
        </router-link>
    </div>
</div>
<div class="contact">
    <p>Let's create someting together.</p>
    <button class="meet"><router-link  to="/contact" style="color:white">Let's meet</router-link></button>
</div>
</div>
</template>

<script>
export default {
  name: "services",
  data(){
      return{
        selectedService: "",
        selectedServicePosition: 0
      }
  },
   mounted(){
    this.selectedService = this.$route.params.service
    this.selectedServicePosition = this.$store.listItems.indexOf(this.selectedService);
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  updated(){
    
  },
   watch: {
    '$route': function(to, from) {
      this.selectedService = this.$route.params.service
      this.selectedServicePosition = this.$store.listItems.indexOf(this.selectedService);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  },
  methods:{
  }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat");
div{
    font-family: 'Montserrat', sans-serif;
}
p{
  text-align:justify;
}
.meet{
    padding: 10px 35px;
    border: 0px;
    background: tomato;
    color: white;
    border-radius: 4px;
}
.contact p:nth-child(1){
    font-size: 24px;
    font-weight: 600;
    text-align: center;
}
.contact{
    padding: 0px 5% 50px 5%;
    text-align: center;
}
.comp-services{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin: 5% 0px;
}
.card:nth-child(2n){
  background: #efefef !important;
}
.service-page-banner{
  background-image:linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url("../assets/services.jpg");
  height: 40vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  margin-top:-20px;
}
.service-page-banner-content{
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  text-transform: uppercase;
  font-size: 2em;
  font-weight: 700;
}
.ecara-highlight{
  padding:4% 15%;
  margin:5% 0px 2% 0px;
  background: #efefef;
  text-align:center;
}

.card-title{
  position:relative !important;
  font-weight: 600 !important;
  font-size:18px !important;
}
.card{
  text-align:center;
  /* margin:20px; */
  padding:20px;
  border:0px;
  box-shadow:0px 0px 0px;
  margin:0px !important;
}
.card-content p{
  text-align:center;
}
.services-wrapper{
  display:flex;
  flex-wrap: wrap;
  align-items:center;
  justify-content: center;
  margin:7% auto;
}
.service-expectation{
  padding:2% 0px 5% 0px;
}
.skill-set{
  margin-bottom:10%;
}
h4{
  font-size:24px;
  font-weight:600;
  margin-bottom:20px;
}
.card-image img{
  width:25% !important;
  margin:auto !important;
  padding:5px !important;
}

</style>